import { cn } from './cn';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const SIZES = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-10 w-10' } as const;

export function Spinner({ size = 'md', className, label = 'Načítání' }: SpinnerProps) {
  return (
    <svg
      className={cn('animate-spin text-current', SIZES[size], className)}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={label}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

/** Centered spinner filling the viewport (route loading). */
export function FullScreenSpinner() {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center text-muted">
      <Spinner size="lg" />
    </div>
  );
}
